import { useEffect } from "react";

function useKeyboardSafeArea() {
  useEffect(() => {
    const root = document.documentElement;

    const update = () => {
      const vv = window.visualViewport;
      if (vv) {
        const offset = Math.max(0, Math.round(window.innerHeight - vv.height));
        root.style.setProperty("--kb-offset", `${offset}px`);
        root.style.setProperty("--vvh", `${Math.round(vv.height)}px`);
      } else {
        root.style.setProperty("--kb-offset", `0px`);
        root.style.setProperty("--vvh", `100svh`);
      }
    };

    update();
    const vv = window.visualViewport;
    vv && vv.addEventListener("resize", update);
    vv && vv.addEventListener("scroll", update);
    window.addEventListener("orientationchange", update);
    window.addEventListener("resize", update);

    return () => {
      vv && vv.removeEventListener("resize", update);
      vv && vv.removeEventListener("scroll", update);
      window.removeEventListener("orientationchange", update);
      window.removeEventListener("resize", update);
    };
  }, []);
}

export default function AppShell({ children }) {
  useKeyboardSafeArea();
  return <div className="app">{children}</div>;
}
